import React, { useState, useEffect, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { LanguageContext } from "./LanguageContext";
import "./css/Navbar.css";
import logo from "./images/logo3.png";

const Navbar = () => {
  const { loginWithRedirect, logout, isAuthenticated, user } = useAuth0();
  const { language, toggleLanguage } = useContext(LanguageContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const [recursosOpen, setRecursosOpen] = useState(false);
  const history = useHistory();

  useEffect(() => {
  }, [isAuthenticated, user]);

  const handlePlanilhaClick = () => {
    setMenuOpen(false);
    setRecursosOpen(false);
    // Navigate to home and scroll to download section
    if (window.location.pathname === "/") {
      document.getElementById("download-section")?.scrollIntoView({ behavior: "smooth" });
    } else {
      history.push("/?scrollTo=download-section");
    }
  };


  return (
    <nav className="navbar">
      <Link to="/" onClick={() => setMenuOpen(false)}>
      <img src={logo} alt="InvestDecoded Logo" className="logo" />
      </Link>

      {/* Language Selector */}
      <button className="language-button" onClick={toggleLanguage}>
        {language === "en" ? "🇧🇷 Português" : "🇺🇸 English"}
      </button>
      
      {/* Menu Icon for Mobile */}
      <div
        className={`menu-icon ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        role="button"
        tabIndex={0}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Navigation Links */}
      <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
        <li><Link to="/" onClick={() => setMenuOpen(false)}>{language === "pt" ? "Início" : "Home"}</Link></li>
        <li><Link to="/courses" onClick={() => setMenuOpen(false)}>{language === "pt" ? "Cursos" : "Courses"}</Link></li>
        <li><Link to="/tutoring" onClick={() => setMenuOpen(false)}>{language === "pt" ? "Tutoria" : "Tutoring"}</Link></li>
        {/*<li><Link to="/careers" onClick={() => setMenuOpen(false)}>{language === "pt" ? "Carreiras" : "Careers"}</Link></li>*/}

        {/* Recursos Dropdown */}
        <li
          className="dropdown"
          onMouseEnter={() => !menuOpen && setRecursosOpen(true)}
          onMouseLeave={() => !menuOpen && setRecursosOpen(false)}
        >
          <span
            className="dropdown-trigger"
            onClick={() => setRecursosOpen(!recursosOpen)}
          >
            {language === "pt" ? "Recursos" : "Resources"} <span className="dropdown-arrow">▾</span>
          </span>
          <ul className={`dropdown-menu ${recursosOpen ? "open" : ""}`}>
            <li>
              <Link to="/blog-guides" onClick={() => { setMenuOpen(false); setRecursosOpen(false); }}>
                {language === "pt" ? "Guias" : "Guides"}
              </Link>
            </li>
            <li>
              <Link to="/retirementcalculator" onClick={() => { setMenuOpen(false); setRecursosOpen(false); }}>
                {language === "pt" ? "Aposentadoria" : "Retirement"}
              </Link>
            </li>
            <li>
              <button className="dropdown-link-btn" onClick={handlePlanilhaClick}>
                {language === "pt" ? "Planilha" : "Spreadsheet"}
              </button>
            </li>
          </ul>
        </li>

        {isAuthenticated ? (
          <>
            <li><span className="welcome-message">Welcome, {user?.name}!</span></li>
            <li>
              <button className="logout-button" onClick={() => logout({ returnTo: window.location.origin })}>
                Logout
              </button>
            </li>
          </>
        ) : (
          <li>
            <button
              className="login-button"
              onClick={() => {
                localStorage.setItem("auth_redirect_path", window.location.pathname);
                loginWithRedirect();
              }}
            >
              Login
            </button>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Navbar;
